import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { incrementalsRoutes } from 'app/siq-applications/modules/incrementals/routes/incrementals-routes';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(incrementalsRoutes)
  ],
  exports: [RouterModule]
})
export class IncrementalsRoutingModule { }
